import React from "react";
import { CheckIcon, UnCheckIcon } from "./Icon";
import Input from "./Input";
import MarqueeSection from "./MarqueeSection";

const TokenCreatorSection = () => {
	const [value, setValue] = React.useState({
		name: "",
		symbol: "",
		description: "",
		decimals: "",
		supply: "",
		image: "/img/token-overview.png",
	});
	const [extension, setExtension] = React.useState([]);
	const [files, setFiles] = React.useState([]);
	React.useEffect(() => {
		if (files.length > 0) {
			const reader = new FileReader();
			reader.onload = (e) => {
				setValue({ ...value, image: e.target.result });
			};
			reader.readAsDataURL(files[0]);
		}
	}, [files]);

	return (
		<section
			className="token-creator-section"
			style={{
				background: `url('/img/token-creators-bg.png') no-repeat top center / cover`,
			}}
		>
			<MarqueeSection />
			<div className="container pt-4">
				<h3 className="mb-4 text-center pt-2">
					<span className="poppins token-creator-title text-capitalize text-gradient d-inline-block">
						Token Creator
					</span>
				</h3>
				<div className="row g-4">
					<div className="col-lg-6">
						<div className="token-creator-card">
							<h6 className="token-creator-card-subtitle mb-3">
								Details
							</h6>
							<div className="form-group mb-3">
								<label className="form-label">Image *</label>
								<label className="position-relative d-block">
									<span className="choose-file-thumb">
										Choose Image
									</span>
									<input
										type="file"
										className="form-control text-transparent"
										onChange={(e) => {
											setFiles(e.target.files);
										}}
									/>
								</label>
							</div>
							<div className="mb-3">
								<Input
									label="Name *"
									value={value.name}
									onChange={(e) =>
										setValue({ ...value, name: e.target.value })
									}
								/>
							</div>
							<div className="mb-3">
								<Input
									label="Symbol *"
									value={value.symbol}
									onChange={(e) =>
										setValue({ ...value, symbol: e.target.value })
									}
								/>
							</div>
							<div className="mb-3">
								<Input
									label="Description *"
									value={value.description}
									onChange={(e) =>
										setValue({
											...value,
											description: e.target.value,
										})
									}
								/>
							</div>
							<div className="mb-3">
								<Input
									label="Decimals *"
									value={value.decimals}
									type="number"
									onChange={(e) =>
										setValue({ ...value, decimals: e.target.value })
									}
								/>
							</div>
							<div className="mb-3">
								<Input
									label="Supply *"
									value={value.supply}
									onChange={(e) =>
										setValue({ ...value, supply: e.target.value })
									}
								/>
							</div>
							<h6 className="token-creator-card-subtitle pt-3 mb-3">
								Extensions
							</h6>
							<div className="extensions-wrapper">
								{extensions.map((item, index) => (
									<CheckedGroup
										key={index}
										extension={extension}
										setExtension={setExtension}
										item={item}
									/>
								))}
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="token-creator-card">
							<h6 className="token-creator-card-subtitle mb-3">
								Overview
							</h6>
							<img
								src={value.image}
								alt=""
								className="w-100"
								style={{
									border: "3px dashed #505050",
									boxSize: "padding-box",
									aspectRatio: "521/268",
									objectFit: "cover",
								}}
							/>
							<div className="token-create-content">
								<div className="item">
									<div className="left">Name</div>
									<div className="right">{value.name}</div>
								</div>
								<div className="item">
									<div className="left">Description</div>
									<div className="right text-sm">
										{value.description}
									</div>
								</div>
								<div className="item">
									<div className="left">Symbol</div>
									<div className="right">{value.symbol}</div>
								</div>
								<div className="item">
									<div className="left">Supply</div>
									<div className="right">{value.supply}</div>
								</div>
								<div className="item">
									<div className="left">Decimels</div>
									<div className="right">{value.decimals}</div>
								</div>
							</div>
							<h6 className="token-creator-card-subtitle mt-3 pt-4 mb-3">
								Extensions
							</h6>
							<ul className="extensions">
								{extension.map((item, index) => (
									<li key={index}>{item.name}</li>
								))}
							</ul>
							<button
								type="submit"
								className="btn-base border-0 w-100 rounded-8"
							>
								Create Token
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

const CheckedGroup = ({ setExtension, extension, item }) => {
	const [checked, setChecked] = React.useState(false);
	return (
		<>
			<label className="form-check form--check">
				<input
					className="form-check-input"
					type="checkbox"
					value=""
					onChange={(e) => {
						setChecked(e.target.checked);
						if (e.target.checked) {
							setExtension([...extension, item]);
						} else {
							setExtension(
								extension.filter((ext) => ext.name !== item.name)
							);
						}
					}}
				/>
				{checked ? (
					<div className="checked-icon">
						<CheckIcon />
					</div>
				) : (
					<div className="unchecked-icon">
						<UnCheckIcon />
					</div>
				)}
				<span>{item.name}</span>
			</label>
		</>
	);
};
const extensions = [
	{
		name: "Transfer Tax",
	},
	{
		name: "Permanent Delegate",
	},
	{
		name: "Interest Bearing",
	},
	{
		name: "Non-Transferable",
	},
	{
		name: "Default Discount State",
	},
];
export default TokenCreatorSection;
